<div id="project-base">
  <div id="project-sidebar" class="reportes-menu-tutorial" *ngIf="showSidebarAndHeader">
    <kuv-sidebar [logo]="logo" [routes]="sesion.routes"></kuv-sidebar>
  </div>
  <div id="banner-vencimiento" class="text-white text-center d-flex justify-content-center align-items-center"
    *ngIf="sesion.user.cuenta_prueba" (click)="cambiarPrueba()">
    <i class="fas fa-info-circle me-2"></i>
    <div>Estás en tu periodo de prueba - <b>PLAN {{getPlan()}}</b> - <label style="text-decoration: underline;">Pulse
        <b>aquí</b> para probar otro plan</label>.</div>
  </div>
  <div id="banner-vencimiento" class="text-white text-center d-flex justify-content-center align-items-center"
    *ngIf="!sesion.user.cuenta_prueba && sesion.user.vencimiento_suscripcion < fechaAlertaVencimientoSuscripcion && !hideTopInfoBar"
    (click)="soporteLubriKuv()">
    <i class="fas fa-info-circle me-2"></i>
    <div
      *ngIf="obtenerDiasHastaVencimiento() != null && obtenerDiasHastaVencimiento() > 0 && obtenerDiasHastaVencimiento() < 8">
      Tu suscripción vence en {{diasHastaVencimiento}} días. No olvides realizar el pago.
    </div>
    <div *ngIf="diasHastaVencimiento == 0">
      Tu suscripción está a punto de vencer. No olvides realizar el pago.
    </div>
    <div *ngIf="obtenerDiasHastaVencimiento() >= DIAS_TRAS_VENCIMIENTO_LIMITE && obtenerDiasHastaVencimiento() < 0">
      <label style="font-weight: bold; cursor: pointer;">¡Tu suscripción ha vencido!</label>&nbsp;<label
        style="text-decoration: underline; font-weight: bold; cursor: pointer;">¡Realiza tu pago a la brevedad o se
        restringirá el acceso
        a tu cuenta!</label>.
    </div>
    <div *ngIf="obtenerDiasHastaVencimiento() < DIAS_TRAS_VENCIMIENTO_LIMITE">
      <label style="font-weight: bold; cursor: pointer;">¡Tu suscripción ha vencido!</label>&nbsp;<label
        style="text-decoration: underline; cursor: pointer;">Para utilizar el sistema realiza el pago</label>.
    </div>
  </div>
  <div id="project-header" *ngIf="showSidebarAndHeader">
    <ng-template #popTitle><label style="font-weight: 600;">Notificaciones</label></ng-template>
    <ng-template #popContent>
      <div class="d-flex flex-column gap-2 p-3 custom-sidebar" style="max-height: 500px; overflow: auto;">
        <div *ngIf="stockCriticos.length == 0">
          No existen notificaciones.
        </div>
        <div class="card p-1" *ngFor="let s of stockCriticos;" (click)="verStockCritico()">
          <div class="tag p-1 warning d-flex align-items-center gap-2" *ngIf="s.cantidad != 0">
            <i class="fas fa-exclamation-circle"></i>
            <div>El producto <b>{{s.producto.nombre}}</b> tiene {{s.cantidad}} unidad(es) de un mínimo de
              {{s.producto.stock_minimo}}.</div>
          </div>
          <div class="tag p-1 danger d-flex align-items-center gap-2" *ngIf="s.cantidad == 0">
            <i class="fas fa-times-circle"></i>
            <div>El producto <b>{{s.producto.nombre}}</b> se ha quedado sin stock.</div>
          </div>
        </div>
        <a class="btn-link" style="cursor: pointer;" (click)="verStockCritico()">Ver detalles...</a>
      </div>
    </ng-template>

    <div class="busqueda d-lg-inline mx-2 d-none"><app-busqueda></app-busqueda></div>

    <button class="btn btn-primary mx-2" (click)="crearOT()" placement="bottom"
      [ngbTooltip]="'Crear nueva orden de trabajo'">
      <i class="fas fa-add"></i> <span class="d-none d-lg-inline ms-2">Crear OT</span>
    </button>

    <button class="btn btn-primary mx-2" (click)="soporteLubriKuv()" placement="bottom"
      [ngbTooltip]="'Solicitar Asistencia'">
      <i class="fa-regular fa-circle-question"></i><span class="d-none d-lg-inline ms-2">Ayuda</span>
    </button>

    <div *ngIf="sesion.sucursales.length > 0" class="mx-3 d-none d-md-flex" placement="bottom"
      [ngbTooltip]="'Sucursal activa'">
      <select class="form-select" id="sucursal" [(ngModel)]="sesion.sucursalIndex" (change)="changeScope($event)">
        <ng-container *ngFor="let s of sesion.sucursales; let i = index">
          <option [value]="i">{{s.nombre}}</option>
        </ng-container>
      </select>
    </div>

    <button type="button" class="btn btn-kuv tool-btn position-relative" placement="bottom-right"
      [ngbTooltip]="'Notificaciones'" [ngbPopover]="popContent" [popoverTitle]="popTitle" popoverClass="custom-popover">
      <i class="fas fa-bell"></i>
      <span class="position-absolute top-50 start-100 translate-middle badge rounded-pill text-bg-danger"
        *ngIf="stockCriticos.length != 0">{{stockCriticos.length}}</span>
    </button>

    <div ngbDropdown class="d-inline-block mx-2">
      <button class="btn btn-kuv" id="dropdownBasic1" placement="bottom" [ngbTooltip]="'Perfil y opciones'"
        ngbDropdownToggle>
        <i class="fas fa-user"></i><span class="mx-2 d-none d-sm-inline"> Mi Cuenta</span>
      </button>

      <button class="btn btn-primary ms-2" (click)="realizarPagoPremium()"
        *ngIf="sesion.user.cuenta_prueba && habilitarSuscripciones && sesion.enableSubscriptionUI"><i
          class="fas fa-rocket me-2"></i> Pasar a Premium</button>

      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button ngbDropdownItem (click)="verPerfil()" style="color: #555555;">
          <div class="d-flex gap-3 my-2">
            <span class="mr-4">
              <i class="fas fa-user-alt"></i>
            </span>
            <div>Ver Perfil</div>
          </div>
        </button>
        <button *ngIf="sesion.esAdmin" ngbDropdownItem (click)="verSuscripcion()" style="color: #555555;">
          <div class="d-flex gap-3 my-2">
            <span class="mr-4">
              <i class="fas fa-circle-info"></i>
            </span>
            <div>Ver Mi Suscripción</div>
          </div>
        </button>
        <button ngbDropdownItem (click)="goToSettings()" style="color: #555555;">
          <div class="d-flex gap-3 my-2">
            <span class="mr-4">
              <i class="fas fa-gear"></i>
            </span>
            <div>Configuración</div>
          </div>
        </button>
        <button ngbDropdownItem (click)="changePass()" style="color: #555555;">
          <div class="d-flex gap-3 my-2">
            <span class="mr-4">
              <i class="fas fa-key"></i>
            </span>
            <div>Cambiar Contraseña</div>
          </div>
        </button>
        <button ngbDropdownItem (click)="mostrarVersion()" style="color: #555555;">
          <div class="d-flex gap-3 my-2">
            <span class="mr-4">
              <i class="fas fa-info-circle"></i>
            </span>
            <div>Versión 7.1.7</div>
          </div>
        </button>
        <button ngbDropdownItem (click)="logout()" style="color: #555555;">
          <div class="d-flex gap-3 my-2">
            <span class="mr-4">
              <i class="fas fa-sign-out-alt"></i>
            </span>
            <div>Cerrar Sesión</div>
          </div>
        </button>
      </div>
    </div>

    <button type="button" class="d-none d-lg-block btn btn-kuv tool-btn position-relative" placement="bottom-right"
      [ngbTooltip]="'Enviar sugerencia'" (click)="enviarSugerencia()">
      <i class="fas fa-comment-dots"></i>
    </button>

    <div *ngIf="showSidebarAndHeader">
      <app-floating-help-button></app-floating-help-button>
    </div>

    <button type="button" class="d-none d-md-block btn btn-kuv tool-btn position-relative" placement="bottom-right"
      [ngbTooltip]="sesion.darkTheme ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'" (click)="cambiarTema()">
      <i class="fas fa-sun" *ngIf="sesion.darkTheme"></i>
      <i class="fas fa-moon" *ngIf="!sesion.darkTheme"></i>
    </button>

  </div>

  <div class="toast-wrapper-center" *ngIf="showSidebarAndHeader">
    <ngb-toast *ngIf="versionService.showNewVersionToast" [autohide]="false"
      style="--bs-toast-padding-x: 8px; --bs-toast-padding-y: 8px; --bs-toast-border-radius: 10px; --bs-toast-max-width: 100%;"
      (hidden)="versionService.showNewVersionToast = false">
      <div class="d-flex align-items-center">
        <div class="toast-body w-100">
          <div class="d-flex flex-row align-items-center gap-1 justify-content-between">
            <label class="d-flex">Existe una nueva versión del sistema.</label>
            <button type="button" aria-label="Actualizar" class="btn btn-link"
              (click)="reloadPage()">Actualizar</button>
          </div>
        </div>
        <button class="btn-close btn-close-white" (click)="versionService.showNewVersionToast = false"></button>
      </div>
    </ngb-toast>
  </div>


  <div id="project-container" [ngClass]="{'no-sidebar': !showSidebarAndHeader}">
    <kuv-loading></kuv-loading>
    <kuv-alert></kuv-alert>
    <router-outlet></router-outlet>
  </div>
</div>